import * as React from 'react';

import CroppedProductImage  from './CroppedProductImage';
import ProductInfoText from '../products/ProductInfoText';
import AdjustQuantity from './AdjustQuantity';
import ProductWeightPill from './ProductWeightPill';
import StaffPick from './StaffPick';
import MediumButton from '../styleguide/MediumButton';

import PropTypes from 'prop-types';

import styles from './ProductDetailsCard.module.css';
/**
 *  This component displays the detailed product view in the modal popup and the single product SEO page 
 */
const ProductDetailsCard= (
  {
    Id,
    name,
    brand,
    category,
    imageInfo,
    description,
    cost_usa_cents,
    thc_lab_value,
    thc_lab_units,
    cbd_lab_value,
    cbd_lab_units,
    cannabisType,
    grams,
    leaf_logix_pricing_tier,
    isModal=true,
    handleClick
  }) => {
 
  // These are all strings
  const showProductInfoText = cbd_lab_value || thc_lab_value || cannabisType;
 
  // Add to cart and auto-close modal
  const addToCartClick = (event) => {
    event.stopPropagation();
    handleClick(itemCount); 
  }; 

  const [itemCount, setItemCount] = React.useState(1);
  const [displayTotal, setDisplayTotal] = React.useState();
  const [formattedPrice, setFormattedPrice] = React.useState();

  React.useEffect(() => {
    // handle button price
    setDisplayTotal(
      parseFloat(Math.round((itemCount * cost_usa_cents))/100).toFixed(2) 
    );
    setFormattedPrice(
      parseFloat(Math.round(cost_usa_cents)/100).toFixed(2)
    );
  }, [itemCount, cost_usa_cents]);
  
  const formattedDesc = description
    ? description.replace(/\n/g, "<br />")
    : 'No Description';

  // This component is used in a modal as well as on the SEO single-product page
  const cardClass = isModal ? styles.modalCard : styles.nonModal; 

  return (
    <div key={`${Id}-modal`} className={cardClass}>
      <div className={styles.scrollingContent}>
        <div className={styles.productImageWrap}>
          <CroppedProductImage 
            productName={name} 
            src={imageInfo.productImage}
            category={imageInfo.productCategory}
            isWide />
        </div>  
        <div className={styles.productBody}>
          <div className={styles.productName}>
            <div>
              <div className={styles.staffPickWrap}>
                <StaffPick withStar />
              </div>
            </div>
            {name}
          </div>
          { formattedPrice && 
            <ProductWeightPill grams={grams} category={category} price={formattedPrice} />
          }
        </div>
        { brand && 
          <div className={styles.brand}>
            {brand}
          </div>
        }
        { showProductInfoText &&
            <div className={styles.productInfo}>
              <ProductInfoText
                thcVal={thc_lab_value}
                thcUnits={thc_lab_units}
                cbdVal={cbd_lab_value}
                cbdUnits={cbd_lab_units}
                cannabisType={cannabisType} />
            </div>
          }
        <div className={styles.productDescWrap}>
          <div className={styles.productDescLabel}>
            Description
          </div>
          <div 
            className={styles.productDesc}
            dangerouslySetInnerHTML={{ __html:formattedDesc }}>
          </div>
        </div>
      </div>
      <div className={styles.controlsWrap}>  
        <div className={styles.adjustQuantityWrap}>
          <AdjustQuantity count={itemCount} setCount={setItemCount} />
        </div>
        <div className={styles.productButtonWrap}>
          <MediumButton text={`Add to Cart - $${displayTotal}`} handleClick={addToCartClick} />
        </div>
      </div>
    </div>
  )
}

ProductDetailsCard.propTypes = {
  Id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  brand: PropTypes.string,
  category: PropTypes.object.isRequired,
  description: PropTypes.string,
  imageInfo: PropTypes.object.isRequired,
  cost_usa_cents: PropTypes.number,
  thc_lab_value: PropTypes.string,
  thc_lab_units: PropTypes.string,
  cbd_lab_value: PropTypes.string,
  cbd_lab_units: PropTypes.string,
  cannabisType: PropTypes.string,
  grams: PropTypes.number,
  leaf_logix_pricing_tier: PropTypes.object, /* bulk products only */
  handleClick: PropTypes.func.isRequired
};

export default ProductDetailsCard;
